import styled from 'styled-components';
import ArrowCircleDownIcon from '@mui/icons-material/ArrowCircleDown';
import LocalMallIcon from '@mui/icons-material/LocalMall';
import Badge from '@mui/material/Badge';
import { useContext } from 'react';
import { CartItemsContext } from '../../context/CartItemsContext';
import { CartItemsContextType } from '../../context/types/CartItemsContextType';
import { FiltersContext } from '../../context/FiltersContext';
import { FiltersContextType } from '../../context/types/FiltersContextType';
import { UploadLookContext } from '../../context/UploadLookContext';
import { UploadLookContextType } from '../../context/types/UploadLookContextType';
import { TextRegular, TextStylistHeader } from '../Text';
import {
  MIN_PC_S_BODY_WIDTH,
  MIN_TABLET_BODY_WIDTH,
} from '../../constants/StylistConstants';

const Navbar = () => {
  const { showFilters, saveShowFilters } = useContext(
    FiltersContext,
  ) as FiltersContextType;

  const { showUploadLook, saveShowUploadLook } = useContext(
    UploadLookContext,
  ) as UploadLookContextType;

  const tabletDisplay: boolean = window.innerWidth < MIN_PC_S_BODY_WIDTH;

  const showFiltersModal = () => {
    if (!showFilters && showUploadLook) saveShowUploadLook(false);
    saveShowFilters(!showFilters);
  };

  const showUploadModal = () => {
    if (!showUploadLook && showFilters) saveShowFilters(false);
    saveShowUploadLook(!showUploadLook);
  };

  const { cartItems } = useContext(CartItemsContext) as CartItemsContextType;
  return (
    <Container>
      {tabletDisplay && (
        <HeaderWrapper>
          <TextStylistHeader fontWeight={600}>
            Mannequin Stylist
          </TextStylistHeader>
        </HeaderWrapper>
      )}
      {tabletDisplay && <LineBreaker></LineBreaker>}
      <Wrapper>
        <Left>
          <ArrowCircleDownIcon />
          <UploadLook>
            <TextRegular
              fontWeight={600}
              onClick={() => {
                showUploadModal();
              }}
            >
              upload reference look
            </TextRegular>
          </UploadLook>
        </Left>
        {!tabletDisplay && (
          <TextStylistHeader fontWeight={600}>
            Mannequin Stylist
          </TextStylistHeader>
        )}
        <Right>
          <Filters>
            <TextRegular
              fontWeight={600}
              onClick={() => {
                showFiltersModal();
              }}
            >
              +&nbsp;&nbsp; Filters
            </TextRegular>
          </Filters>
          <Badge
            style={{ cursor: 'pointer' }}
            badgeContent={cartItems}
            color="primary"
          >
            <LocalMallIcon />
          </Badge>
        </Right>
      </Wrapper>
      <LineBreaker></LineBreaker>
    </Container>
  );
};

const Container = styled.div``;

const HeaderWrapper = styled.div`
  height: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Wrapper = styled.div`
  display: flex;
  padding: 18px 0;

  @media (max-width: ${MIN_PC_S_BODY_WIDTH - 1}px) {
    display: grid;
    grid-template-columns: auto 0fr;
    align-items: center;
  }
`;

const LineBreaker = styled.div`
  position: absolute;
  left: 0;
  width: 100%;
  border-bottom: 1px solid rgba(0, 0, 0, 0.4);
`;

const Left = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  cursor: pointer;
`;
const UploadLook = styled.div`
  margin-left: 15px;
  @media (max-width: ${MIN_PC_S_BODY_WIDTH - 1}px) {
    margin-left: 10px;
  }
`;

const Right = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  @media (max-width: ${MIN_PC_S_BODY_WIDTH - 1}px) {
    display: -webkit-box;
    width: 160px;
  }

  @media (max-width: ${MIN_TABLET_BODY_WIDTH - 1}px) {
    display: -webkit-box;
    width: 100px;
  }
`;

const Filters = styled.div`
  cursor: pointer;
  margin-right: 146px;

  @media (max-width: ${MIN_PC_S_BODY_WIDTH - 1}px) {
    margin-right: 66px;
  }

  @media (max-width: ${MIN_TABLET_BODY_WIDTH - 1}px) {
    margin-right: 20px;
  }
`;

export default Navbar;
